import { makeStyles, Theme } from '@material-ui/core';
import { StyleRules } from '@material-ui/core/styles';

import { IStyleProps, PropsClasses } from '../../types/StyleProps';
import commonStyles from '../../assets/jss/commonStyles';

export const useStyles = makeStyles<Theme, IStyleProps>(() => commonStyles as StyleRules);
export const useDefaultStyles = (): PropsClasses => useStyles({} as IStyleProps);
